module.exports = __webpack_public_path__ + "static/media/infoJumbo4.672981b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/demmeler/images/infoJumbo4.jpg
// module id = 594
// module chunks = 0